import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import VideoPlayer from "../media/video-player";

import { Vid } from "../../types/skills";

const VideoViewDialog = ({
  open,
  setOpen,
  vid,
}: {
  open: boolean;
  setOpen: (state: boolean) => void;
  vid: Vid | undefined;
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="video-view-dialog"
      sx={{ minWidth: 300, minHeight: 300 }}
    >
      <DialogTitle
        id="video-view-dialog"
        className="font-head"
        sx={{ textAlign: "center" }}
      >
        {vid?.title || ""}
      </DialogTitle>
      <DialogContent>
        <VideoPlayer urls={vid?.url ? [vid.url] : (vid?.urls || [])} />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          color="secondary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default VideoViewDialog;
